






















































import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import OauthMixin from "@/mixins/http/OauthMixin";
import { projectStore } from "@/store/typed";
import Topbar from "@/components/TheTopbar.vue";
//import Sidebar from "@/components/TheSidebar.vue";

@Component({ components: { Topbar } })
export default class Login extends mixins(OauthMixin) {
  async createProjectAndOpenDesigner() {
    const project = await projectStore.startNewProject();

    this.$router.push({ name: "project-design", params: { id: project.id } });
  }
}
